module.exports = __webpack_public_path__ + "media/images/logos/courtsdesk-text-color-200x68-0e8b66a2bd6bb6d81646ce82ebe96d50.png";